import { render } from "./AppLoaderScreen.vue?vue&type=template&id=59ca70af&scoped=true"
import script from "./AppLoaderScreen.vue?vue&type=script&lang=js"
export * from "./AppLoaderScreen.vue?vue&type=script&lang=js"

import "./AppLoaderScreen.vue?vue&type=style&index=0&id=59ca70af&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-59ca70af"]])

export default __exports__